"use strict";

var avatarSchema = require('./avatarSchema');

var activityTypes = require('./activityTypes.json');

var boundingBoxSchema = require('./boundingBoxSchema.json');

var gpsPointSchema = require('./gpsPointSchema');

var statsSchema = require('./statsSchema');

var elevationCorrectionTypeProbability = require('./elevationCorrectionTypeProbabilitySchema');

var ActivityCoreSchema = function ActivityCoreSchema(schemaType) {
  var coreSchema = {
    type: 'object',
    required: ['accountId', 'activityId', 'activityType'],
    additionalProperties: false,
    properties: {
      accountId: {
        type: 'string'
      },
      accountName: {
        type: 'string'
      },
      activityId: {
        type: 'string',
        pattern: "^[\u4E00-\u9FA5\uF900-\uFA2Da-zA-Z0-9-_@]*$"
      },
      activityIdx: {
        type: 'number'
      },
      title: {
        type: ['string', 'null']
      },
      description: {
        type: 'string'
      },
      activityType: {
        type: 'string',
        pattern: Object.keys(activityTypes).join('|')
      },
      includedInScene: {
        type: 'array',
        items: {
          type: 'object',
          required: ['accountId', 'sceneId'],
          additionalProperties: false,
          properties: {
            accountId: {
              type: 'string'
            },
            sceneId: {
              type: 'string'
            },
            settings: {
              type: 'object',
              // These are practically anything from the scene object.
              // It's doesn't seem to be precisely defined what is
              // supposed to go in here.
              properties: {}
            },
            thumbnail: {
              type: 'string'
            }
          }
        }
      },
      private: {
        type: 'boolean'
      },
      live: {
        type: 'boolean'
      },
      processed: {
        type: 'boolean'
      },
      color: {
        type: 'string',
        pattern: '(^#(0x|0X)?[a-fA-F0-9]+$)|(rgb\\(\\s?(\\d{1,3}),\\s?(\\d{1,3}),\\s?(\\d{1,3})\\))'
      },
      opacity: {
        type: 'number',
        minimum: 0,
        maximum: 1
      },
      avatar: avatarSchema,
      altitudeOffset: {
        type: 'number'
      },
      elevationCorrectionType: {
        type: 'integer',
        minimum: 1,
        maximum: 4
      },
      predictedElevationCorrectionType: {
        type: 'integer',
        minimum: 1,
        maximum: 2
      },
      elevationCorrectionTypeProbability: elevationCorrectionTypeProbability,
      locationName: {
        type: 'string'
      },
      stats: statsSchema,
      startPoint: gpsPointSchema('height', 'time'),
      endPoint: gpsPointSchema('height', 'time'),
      bounds: boundingBoxSchema,
      pathUrl: {
        type: 'string'
      },
      srcFile: {
        type: 'string'
      },
      uploadUrl: {
        type: 'string'
      },
      points: {
        type: 'array',
        items: gpsPointSchema()
      },
      show: {
        type: 'boolean'
      },
      focusable: {
        type: 'boolean'
      },
      waitUntilReady: {
        type: 'boolean'
      },
      trim: {
        type: 'object',
        additionalProperties: false,
        properties: {
          begin: {
            anyOf: [{
              type: 'null'
            }, {
              type: 'number'
            }]
          },
          end: {
            anyOf: [{
              type: 'null'
            }, {
              type: 'number'
            }]
          }
        }
      },
      offsetTime: {
        type: 'number'
      },
      numPoints: {
        type: 'number'
      },
      sideswipeVersion: {
        type: 'string'
      },
      processTimestamp: {
        type: 'string',
        format: 'date-time'
      },
      created: {
        type: 'string',
        format: 'date-time'
      },
      cumulativeDistance: {
        type: 'number'
      },
      abf: {
        type: 'object',
        required: ['versions', 'maxChunkSize'],
        additionalProperties: false,
        properties: {
          versions: {
            type: 'array',
            items: {
              type: 'string'
            }
          },
          extensions: {
            type: 'array',
            items: {
              type: 'string'
            }
          },
          maxChunkSize: {
            type: 'number'
          },
          channels: {
            type: 'array',
            items: {
              type: 'string'
            }
          }
        }
      },
      integration: {
        enum: ['STRAVA'],
        type: 'string'
      }
    }
  };

  switch (schemaType) {
    case 'api':
      delete coreSchema.properties.accountId;
      delete coreSchema.properties.waitUntilReady;
      coreSchema.required = ['activityType'];
      return coreSchema;

    case 'db':
      delete coreSchema.properties.waitUntilReady;
      return coreSchema;

    default:
      return coreSchema;
  }
};

var activitySchema = function activitySchema(schemaType) {
  return ActivityCoreSchema(schemaType);
};

module.exports = activitySchema;